export { default as ProductTypePerformance } from './primary';
